<p>admin-leases works!</p>
